import React, { useId } from "react";
import "../TextInput/TextInput.css";
import "./Textarea.css";

/**
 * Multiline counterpart to TextInput — same surface-aware field chrome
 * (gx-field / gx-field-label / gx-field-help), with an auto-height, vertically
 * resizable control. ...rest spreads onto the native <textarea>.
 */
const Textarea = ({
  label,
  helperText,
  error = false,
  fullWidth = true,
  rows = 4,
  className = "",
  id,
  ...rest
}) => {
  const autoId = useId();
  const fieldId = id || autoId;
  return (
    <div className={`gx-field ${fullWidth ? "is-full" : ""} ${error ? "is-error" : ""} ${className}`}>
      {label && <label htmlFor={fieldId} className="gx-field-label">{label}</label>}
      <textarea
        id={fieldId}
        rows={rows}
        className="gx-field-input gx-field-textarea"
        aria-invalid={error || undefined}
        {...rest}
      />
      {helperText && <div className="gx-field-help">{helperText}</div>}
    </div>
  );
};

export default Textarea;
